import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';

// components
import PageLayout from "../components/PageLayout";

// services
import axiosInstance from "../api/apiClient";

// images
const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png';

const Timeline = () => {
    const params = useParams();
    const navigate = useNavigate();

    const [library, setLibrary] = useState([]);
    const [year, setYear] = useState(2024);
    const [order, setOrder] = useState('Decending');

    useEffect(() => {
        axiosInstance.get('/getUserBooks').then((data:any) => {
            setLibrary(data);
        });

        if (params.year) {
            setYear(parseInt(params.year));
        }
    }, [params.year]);    
    return (
        <PageLayout
            headerText={`Timeline ${params.year}`}
            type="dark"
        >
            <div className="flex gap-y-4">
                <div className="w-1/3">
                    <Menu as="div" className="relative inline-block text-left">
                        <div>
                            <MenuButton className="inline-flex items-center w-full justify-center gap-x-1.5 rounded-md bg-white px-6 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                            {year}
                            {/* <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" /> */}
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="10px" width="10px" version="1.1" id="Layer_1" viewBox="0 0 407.437 407.437">
                                <polygon points="386.258,91.567 203.718,273.512 21.179,91.567 0,112.815 203.718,315.87 407.437,112.815 "/>
                            </svg>
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-100 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            {[2022, 2023, 2024, 2025].map((item) => (
                                item !== year && <div className="py-1">
                                <MenuItem>
                                    <button
                                        onClick={() => setYear(item)}
                                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                    >
                                    {item}
                                    </button>
                                </MenuItem>
                            </div>
                            ))}
                        
                    </MenuItems>
                    </Menu>
                
                </div>
                <ol  className="relative border-s border-gray-200 dark:border-gray-700">
                    {library.filter((book) => new Date(book['Date Read']).getFullYear() === year).sort((a, b) => order === 'Ascending' ? new Date(a['Date Read']).getTime() - new Date(b['Date Read']).getTime() : new Date(b['Date Read']).getTime() - new Date(a['Date Read']).getTime()).map((book) => (
                        <li className="hover:cursor-pointer mb-10 ms-6 min-h-44 relative" onClick={() => navigate(`/book/${book['Book Id']}`)}>   
                            {/* Book icon */}
                            <span className="absolute flex items-center justify-center w-6 h-6 bg-gray-900 rounded-full -start-9 ring-8 ring-gray-900">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 22 22" fill="none">
                                    <path d="M11 3.99995C12.8839 2.91716 14.9355 2.15669 17.07 1.74995C17.551 1.63467 18.0523 1.63283 18.5341 1.74458C19.016 1.85632 19.4652 2.07852 19.8464 2.39375C20.2276 2.70897 20.5303 3.10856 20.7305 3.56086C20.9307 4.01316 21.0229 4.50585 21 4.99995V13.9999C20.9699 15.117 20.5666 16.1917 19.8542 17.0527C19.1419 17.9136 18.1617 18.5112 17.07 18.7499C14.9355 19.1567 12.8839 19.9172 11 20.9999" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10.9995 3.99995C9.1156 2.91716 7.06409 2.15669 4.92957 1.74995C4.44856 1.63467 3.94731 1.63283 3.46546 1.74458C2.98362 1.85632 2.53439 2.07852 2.15321 2.39375C1.77203 2.70897 1.46933 3.10856 1.26911 3.56086C1.0689 4.01316 0.976598 4.50585 0.999521 4.99995V13.9999C1.0296 15.117 1.433 16.1917 2.14533 17.0527C2.85767 17.9136 3.83793 18.5112 4.92957 18.7499C7.06409 19.1567 9.1156 19.9172 10.9995 20.9999" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11 21V4" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            <div className="flex items-center">
                                <h3 className="hover:text-gray-500 flex items-center mb-1 text-lg font-semibold text-gray-900">{book['Title']},</h3>
                                <p className="text-base font-normal text-gray-500 dark:text-gray-400 ml-2">{book['Author']}</p>
                            </div>
                            <time className="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">Read on {new Date(book['Date Read']).toLocaleDateString('nl-NL')}</time>
                            {/* <p className="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">{book['Author']}</p> */}
                            <img src={book['Cover URL'] || noCover} className="w-30 h-40 rounded-lg absolute -start-40 top-[0]" alt="cover"/>
                        </li>
                    ))}                
                </ol>
            </div>
        </PageLayout>
    );

}

export default Timeline;